/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ShiftManagerGroupType {
  CLIENT = 'CLIENT',
  MEDICAL_FACILITY = 'MEDICAL_FACILITY',
  ROOM = 'ROOM',
}
